var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29007 9.87984L5.17007 5.99984L1.29007 2.11984C1.19749 2.02726 1.12405 1.91735 1.07394 1.79638C1.02384 1.67542 0.998046 1.54577 0.998046 1.41484C0.998046 1.28391 1.02384 1.15426 1.07394 1.03329C1.12405 0.912331 1.19749 0.802419 1.29007 0.709837C1.38265 0.617255 1.49256 0.543817 1.61352 0.493711C1.73449 0.443606 1.86414 0.417818 1.99507 0.417818C2.126 0.417818 2.25565 0.443606 2.37661 0.493711C2.49757 0.543817 2.60748 0.617255 2.70007 0.709837L7.29007 5.29984C7.38277 5.39235 7.45632 5.50224 7.5065 5.62321C7.55668 5.74419 7.58251 5.87387 7.58251 6.00484C7.58251 6.13581 7.55668 6.26549 7.5065 6.38646C7.45632 6.50744 7.38277 6.61733 7.29007 6.70984L2.70007 11.2998C2.60755 11.3925 2.49766 11.4661 2.37669 11.5163C2.25572 11.5665 2.12604 11.5923 1.99507 11.5923C1.8641 11.5923 1.73442 11.5665 1.61344 11.5163C1.49247 11.4661 1.38258 11.3925 1.29007 11.2998C0.910068 10.9098 0.900068 10.2698 1.29007 9.87984Z",
    fill: "#8F9BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d5ac88bbde6f98da16e2be4778bd1f41.svg";
export { ForwardRef as ReactComponent };